import React, { useState, useEffect } from 'react'
import { styled } from '@mui/material/styles'
import Layout from '@/product/components/templates/Layout'
import ErpAuction from './ErpAuction'
import Manifest from '../../product/customViews/ERP'
import Inventory from './Inventory'
import PropTypes from 'prop-types'
import AppBar from '@mui/material/AppBar'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import './ERP.css'
import { handleRedirectInternal } from '@/product/common/components'
import { useHistory } from 'react-router-dom'
import { useLocation } from 'react-router-dom'
import ProductListView from '@/product/components/organisms/Product/ProductListView'
const PREFIX = 'ERP'

const classes = {
    root: `${PREFIX}-root`,
}

const StyledLayout = styled(Layout)(({ theme }) => ({
    [`& .${classes.root}`]: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.paper,
    },
}))

function TabPanel(props) {
    const { children, value, index, ...other } = props

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <div>{children}</div>}
        </div>
    )
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
}

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    }
}

const ERP = (props) => {
    const history = useHistory()
    const [value, setValue] = useState(0)
    const location = useLocation()

    let invId = props.match?.params?.id ? props.match.params.id : 0
    const handleChange = (event, newValue) => {
        if (newValue === 0) {
            handleRedirectInternal(history, 'erp')
            setValue(newValue)
        } else if (newValue === 1) {
            handleRedirectInternal(history, 'erp/manifest')
            setValue(newValue)
        } else if (newValue === 2) {
            handleRedirectInternal(history, 'erp/auction/draft')
            setValue(newValue)
        } else if (newValue === 3) {
            handleRedirectInternal(history, 'erp/auction/open')
            setValue(newValue)
        } else if (newValue === 4) {
            handleRedirectInternal(history, 'erp/auction/closed')
            setValue(newValue)
        } else if (newValue === 5) {
            handleRedirectInternal(history, 'erp/auction/all')
            setValue(newValue)
        }
    }

    useEffect(() => {
        if (location) {
            if (location.pathname == '/erp') {
                setValue(0)
            } else if (location.pathname.includes('/erp/manifest')) {
                setValue(1)
            } else if (location.pathname.includes('/erp/auction')) {
                if (props.match.params.action) {
                    let action = props.match.params.action
                    if (action === 'draft') {
                        setValue(2)
                    } else if (action === 'open') {
                        setValue(3)
                    } else if (action === 'closed') {
                        setValue(4)
                    } else {
                        setValue(5)
                    }
                }
            }
        }
    }, [location])

    return (
        <StyledLayout
            noUI={props.noUI || false}
            renderSidePanelDefault={props.renderSidePanelDefault || false}
        >
            {' '}
            <div className="erpTabs">
                <AppBar position="static">
                    <Tabs
                        value={value}
                        onChange={handleChange}
                        aria-label="ERP Tabs"
                    >
                        <Tab label="Inventory" {...a11yProps(0)} />
                        <Tab label="Manifest" {...a11yProps(1)} />
                        {/* <Tab label="Draft Auctions" {...a11yProps(2)} />
                        <Tab label="Active Auctions" {...a11yProps(3)} />
                        <Tab label="Closed Auctions" {...a11yProps(4)} />
                        <Tab label="All Auctions" {...a11yProps(5)} /> */}
                    </Tabs>
                </AppBar>
                <TabPanel value={value} index={0}>
                    <Inventory invId={invId} />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <Manifest invId={invId} />
                </TabPanel>
                <TabPanel value={value} index={2}>
                    <ErpAuction action="draft" />
                </TabPanel>
                <TabPanel value={value} index={3}>
                    <ErpAuction action="open" />
                </TabPanel>
                <TabPanel value={value} index={4}>
                    <ErpAuction action="closed" />
                </TabPanel>
                <TabPanel value={value} index={5}>
                    <ErpAuction action="all" />
                </TabPanel>
            </div>
        </StyledLayout>
    )
}

export default ERP
